import {Icon} from '@wandb/weave/components/Icon';
import React from 'react';
import {Components} from 'react-virtuoso';

import {WorkspaceDrawerScroller} from '../WorkspaceDrawerScroller';

export const Scroller: Components['Scroller'] = WorkspaceDrawerScroller;

/**
 * This component is used as Header/Footer on the virtuoso list to ensure
 * proper top/bottom spacing. Unfortunately I wasn't able to figure out a
 * plain CSS solution that played nicely with Virtuoso. My first instinct
 * was to add top/bottom padding to the Scroller container, but that didn't
 * affect the position of the inner items. Then, I tried adding top/bottom
 * margin to the first/last items in the list. The first item correctly
 * displayed a top margin, but the last item never showed its bottom margin.
 * Next, I tried setting top/bottom padding on a custom List component,
 * but then the scroll stopped working. Finally I resorted to this solution.
 * Though unideal, it's the only option I found that actually works without
 * breaking something else.
 * Related: https://github.com/petyosi/react-virtuoso/issues/238
 */
export const TopBottomSpacing = () => <div className="h-8" />;

export const EmptyPlaceholder = () => (
  <div className="flex h-[calc(100%_-_16px)] w-full flex-col items-center justify-center text-moon-500">
    <div className="mb-16 flex h-[3rem] w-[3rem] items-center justify-center rounded-full bg-moon-300/[0.48]">
      <Icon name="search" className="h-24 w-24" />
    </div>
    <p className="font-semibold">No results found</p>
    <p className="text-sm">Try another search.</p>
  </div>
);
